module.exports = __webpack_public_path__ + "img/docusign-logo.a4c86515.svg";